export const COUNTRYCODE = 'countryCode'
export const REGION = 'region'



// WEBPACK FOOTER //
// ./src/components/Modals/PaymentModal/constants.ts